import { useState, useEffect, } from "react";
import Box from '@mui/material/Box';
import { getEndpoint, getMUICache, getUrl, getImageUrl, getLoggedUserName, logoutUser } from "../../../common/utils";
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
//import InputAdornment from '@mui/material/InputAdornment';
//import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
// import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from '@mui/material';
import MainMenuThree from '../MainMenuThree/MainMenuThree'
import DrawerComponentThree from "../SidebarThree/DrawerComponentThree";
import bcrypt from 'bcryptjs-react';
import './HomeHeaderThree.css';
import { PAGEBUILDER_URLS } from '../../Common/Constant';

HomeHeaderThree.version = 1000;

HomeHeaderThree.lang = 'en';
HomeHeaderThree.langs = [
  'en'
];
HomeHeaderThree.setLang = (lang: any) => {
  HomeHeaderThree.lang = lang;
}

Object.defineProperty(HomeHeaderThree, 'name', {
  writable: true,
  value: 'HomeHeaderThree'
});

// Define a type for the fetch options
interface FetchOptions {
  method: string;
  headers: {
    'Content-Type': string;
    'p-nonce': string;
  };
  credentials?: RequestCredentials; // Use RequestCredentials type
}

export function HomeHeaderThree(props: any) {
  const [menuItems, setMenuItems] = useState<any>([]);
  const [headerData, setHeaderData] = useState<any>({});
  const [showMainMenu, setMainMenu] = useState(false);
  const [toogleMenuData, setToggleMenuData] = useState<any>([]);
  const [Closebtn, setClosebtn] = useState<any>(false);
  //const [searchValue, setSearchValue] = useState<any>("");
  const [SearchBar, setSearchBar] = useState<any>(false);
  const [isActive, setIsActive] = useState <any>(false);
  const [loggedUserName, setLoggedUserName] = useState<any>("");
  const [loginLink, setLoginLink] = useState<any>();

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const {
    onClick,
    showSearch,
    isSticky,
    CONSTANTS
    /*MSID*/
  } = props;

  const endpoint = getEndpoint(props, "MAIN");
  const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const togglerEndpoint = getEndpoint(props, "TOGGLER_MENU_API");
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoginLink( "/login?url=" + encodeURIComponent(window.location.href) );
    if (!endpoint.isSSR || !endpoint.SSRDataObj || !headerMenuEndpoint.isSSR || !headerMenuEndpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, []);


  if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
    setHeaderData(endpoint.SSRDataObj);

    if (isSticky) {
      setTimeout(() => {
        if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
          document.getElementsByTagName("header")[0].classList.add("sticky");
      })
    }
  }

  if (headerMenuEndpoint.isSSR && headerMenuEndpoint.SSRDataObj && headerMenuEndpoint.SSRDataObj.length && (!menuItems || !menuItems.length)) {
    setMenuItems(headerMenuEndpoint.SSRDataObj);
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!toogleMenuData || !toogleMenuData.length)) {
    setToggleMenuData(togglerEndpoint.SSRDataObj);
  }

  const toggleMainMenu = () => {
    if (toogleMenuData.length == 0) {
      getToggleMenuData();
    } else {
      setMainMenu(!showMainMenu);
    }
  }

  const getToggleMenuData = () => {
    let toggleMenuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)

    let headerString = '?' + toggleMenuAPIurl.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};

    fetch(toggleMenuAPIurl, { headers: headers }).then((response) => response.json())
      .then((val) => setToggleMenuData(val))
      .then(() => setMainMenu(true))
  }

  const fetchComponentData = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    let menuAPIurl = getUrl(props, 0, false, "HEADER_MENU_API", true)
    // let document = typeof document !== 'undefined' && undefined !== document && document;

    let headerString = `?` + headerAPI.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const customHeaders = {
      'Content-Type': 'application/json',
      'p-nonce': headerString
    };
    var fetchOptions: FetchOptions = {
      method: 'GET',
      headers: customHeaders
    };

    let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
    headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
    const headers_menuAPIurl = {'p-nonce': headerString_menuAPIurl};

    if (headerAPI.includes('getsiteResources') && !headerAPI.includes("rendering/getsiteResources") &&
      (typeof document !== 'undefined' && undefined !== document && document
        && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
      headerAPI = headerAPI.replace("getsiteResources", "rendering/getsiteResources");
    } else { fetchOptions.credentials = "include"; }
    Promise.all([
      fetch(headerAPI, fetchOptions).then((response) => response.json()),
      fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
    ])
      .then(([result1, result2]) => {
        // Handle the results individually
        setHeaderData(result1);
        setMenuItems(result2);
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error fetching data:', error);
      });
  }


  const toggleMenu = () => {
    document.body.classList.add("modal-open");
};


  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);

  const showSearchBar = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const closehandler = () => {
    setSearchBar(false)
    setClosebtn(false)
  }

  const rendertopBar = () => {

    return <AppBar position="relative" color='default' className={scroll ? "bg-black" : "bg-white"}>
      <Toolbar className='header-top HomeTopHeader'>
        <div className="header-left">
          <div className="sidebar-menu-icon mobileThemeThreeIcon" onClick={() => {toggleMainMenu(); toggleClass(); toggleMenu();}}>
          <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
                <MenuIcon />
            </IconButton>
             {/* <Button className="closebtn" onClick={toggleMainMenu}><CloseIcon /></Button> */}
          </div>
          <div id="HeaderlogoIn" className="">
            <Link href="/" aria-label="logo" target="_self" className="main-logo">
             
              {headerData.mainLogo && <img src={getImageUrl(headerData.mainLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" width="96" height="36" />}
            </Link>
          </div>
          <div className='themeThreeSearchIcon mobileThemeThreeSearch'> 
              {!Closebtn && <SearchIcon onClick={() => showSearchBar()}/>}
              {Closebtn && <CloseIcon onClick={() => closehandler()}/>}

              {(showSearch && SearchBar) &&
              <div className='themeSearchMainWrap'>
                <div className="search-main">
                  <div className="search" >
                  </div>
                </div>
              </div>
            }
            </div>
        </div>
      </Toolbar>
    </AppBar>
  }
  let defaultDomainUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultDomainUrl = "https://" + window.location.hostname;
  } else {
    defaultDomainUrl = (props && props.REQUEST_HOSTNAME) && "https://" + props.REQUEST_HOSTNAME;
  }

  const getLoginString = () => {
    if( loggedUserName ) {
      return <>Welcome {loggedUserName} | <a onClick={logoutUser} href="javascript:void(0)">Logout</a></>
    }
    return <a href={loginLink}>Login</a>
  }

  return (
    <div className="card_wrapper themeThreeMainHeaderWrap" onClick={onClick}>
      <CacheProvider value={getMUICache()}>
        <div style={ { float:"right" } }>
          {getLoginString()}
        </div>
        <Box sx={{ flexGrow: 1 }} className="header themeThreeHeaderWrap">
          <Grid spacing={2} container direction="column">
            <Grid item md={12}>
              {rendertopBar()}
            </Grid>
            <Grid item md={12} className='menu-wrap'>
              {Object.keys(headerData).length && <MainMenuThree 
              menuItems={menuItems} 
              domainUrl={defaultDomainUrl} 
              toggleMainMenu={toggleMainMenu} 
              headerMenuEndpoint={headerMenuEndpoint} 
              cdsDomain={CONSTANTS.CDS_API} 
              L1BgColor={props.L1BgColor} 
              L1TextColor={props.L1TextColor} 
              L2BgColor={props.L2BgColor} 
              L2TextColor={props.L2TextColor}
              showSearch={showSearch} />}
            </Grid>
          </Grid>

          {showMainMenu &&
            <Grid item md={12} className='menu-wrap' style={{ backgroundColor: props.HamburgerBgColor }}>
              <DrawerComponentThree toggleMainMenu={toggleMainMenu} menuItems={toogleMenuData} domainUrl={defaultDomainUrl} HamburgerBgColor={props.HamburgerBgColor} HamburgerTextColor={props.HamburgerTextColor} />
            </Grid>


          }
        </Box>
      </CacheProvider>
    </div>
  );
}